<p *ngIf="data.cliente">Su número de cliente es: {{ data.cliente.ic }}</p>
<p *ngIf="!data.cliente">No se encontró el cliente.</p>

<div class="modal-footer" *ngIf="data.cliente">
  <button class="button1" (click)="copiarNumeroCliente()">Ok</button>
</div>
